import React, {createContext} from "react";
import {IPlanContextProps} from "../models/PlanModel";

const initialContextProps: IPlanContextProps = {
  plan: {},
  setPlan: () => {},
};

export const BuildPlanContext = createContext<IPlanContextProps>(initialContextProps);

export const BuildPlanProvider = BuildPlanContext.Provider;

export const useBuildPlanContext = () => React.useContext(BuildPlanContext);